import React, { useState, useEffect } from 'react'
import { Panel, IconButton, Icon, Row, Col } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../utils/loading'
import { useHistory } from 'react-router-dom'
import CreatePayeeAndTaxInfoTable from './CreatePayeeAndTaxInfoTable'
import CreatePayeeAndTaxInfoForm from './CreatePayeeAndTaxInfoForm'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import ConfirmWidget from '../confirm/ConfirmWidget'

import { saveCreatePayeeAndTax, editCreatePayeeAndTax } from '../../redux/actions/createPayeeAndTax'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import notification from '../../utils/notification'

export default function CreatePayeeAndTaxInfoWidget(props) {
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()

  // const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
const [formSchema, setFormSchema] = useState(props.schema) // เอา .forms ออก
  const [isViewMode, setIsViewMode] = useState(props.isViewMode)
  const [isExpanded, setIsExpanded] = useState(true)
  const [selectRowData, setSelectRowData] = useState()
  const [isExpandedForm, setIsExpandedForm] = useState(true)
  const [isAddBankAccount, setIsAddBankAccount] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const projectCode = sessionStorage.getItem('projectCode')

  const history = useHistory()

  useEffect(() => {
    // setVoucherSchema(mockSchema.model || [])
  }, [])

  const handleGetSchemaEdit = async (id) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await editCreatePayeeAndTax(projectCode, id)
      setSelectRowData(response)
      // console.log('responseEdit', response)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleSelectRowData = (rowData) => {
    // console.log('handleSelectRowData ', rowData)
    //setSelectRowData(rowData)
    setIsAddBankAccount(false)
    setIsExpanded(false)

    handleGetSchemaEdit(rowData.id)
  }

  const handleAddBankAccount = () => {
    setIsAddBankAccount(true)
    setIsExpanded(false)
  }

  const onSubmit = (data) => {
    // console.log('data', data)
    // console.log('selectRowData', selectRowData)
    let request = {
      id: selectRowData?.id ? selectRowData.id : null,
      projectCode: projectCode,
      regiterType: data.regiterType,
      idCard: data.idCard,
      expenseForNameOrOrg: data.expenseForNameOrOrg,
      title: data.titleName,
      lastName: data.lastName,
      address: data.address,
      expenseForTax: data.expenseForTax || false,
      vatRegistration: data.vatRegistration || false,
      roles: data.roles,
      buildingName: data.buildingName,
      roomNumber: data.roomNumber,
      numberOfAddress: data.houseNumber,
      moo: data.villageNumber,
      box: data.lane,
      villageName: data.villageName,
      roadName: data.road,
      location: data.location,
      branchCode: data.branchCode,
      email: data.email,
      phoneNumber: data.phoneNumber,
      subProjectCode: data.subProjectCode,
    }
    // setIsShowConfirm(true)
    handleCallService(request)
    // console.log('onSubmit', request)
  }

  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)
    // setIsError(false)

    try {
      let response = await saveCreatePayeeAndTax(projectCode, request)
      if (response) {
        // clearValues()
        setIsExpanded(true)
        setIsAddBankAccount(false)
        setSelectRowData()
        setFormSchema(response.forms)
        // console.log('response', response)
      } else {
        // setIsError('ไม่สำเร็จ')
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      // setIsError(e.response.data.errors?.message || DEFAULT_ERR_MSG)
      notification.open('error', {
        title: e.response.data.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  return (
    <>
      <Panel
        shaded
        collapsible
        defaultExpanded
        header={'ข้อมูลผู้รับเงินและข้อมูลภาษี'}
        bordered
        expanded={isExpanded}
        onSelect={() => {
          setIsExpanded(!isExpanded)
        }}
      >
        <>
          {/* --- แก้ไข 2: ส่ง Props ลงไปให้ครบถ้วนและชื่อตรงกัน --- */}
          <CreatePayeeAndTaxInfoTable
            schema={formSchema?.valus}
            loading={isLoading}
            onSelect={handleSelectRowData}
            isViewMode={isViewMode}
            searchSchema={props.schema.searchForm} // แก้จาก searchSchema เป็น seachSchema ให้ตรงกับที่ไฟล์ลูกรับค่า
            projectCode={projectCode} // เพิ่มการส่ง projectCode
         
          />

          {!isViewMode && (
            <IconButton
              appearance="primary"
              icon={<Icon icon="plus" />}
              onClick={() => {
                handleAddBankAccount()
              }}
              //size="sm"
              style={{ float: 'right', marginTop: 10, marginBottom: 10 }}
            >
              เพิ่ม
            </IconButton>
          )}
        </>
      </Panel>

      <br />

      {(isAddBankAccount || selectRowData) && (
        <Panel
          shaded
          collapsible
          defaultExpanded
          header={isAddBankAccount ? 'เพิ่ม' : 'แก้ไข'}
          bordered
          expanded={isExpandedForm}
          onSelect={() => {
            setIsExpandedForm(!isExpandedForm)
          }}
        >
          <CreatePayeeAndTaxInfoForm
            schema={formSchema}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            clearErrors={clearErrors}
            rowData={selectRowData}
            isAddBankAccount={isAddBankAccount}
          />

          <hr />
          {/* {isError && (
            <Message style={{ marginBottom: 10 }} showIcon type="error" description={isError} />
          )} */}
          <Row>
            <Col style={{ textAlign: 'end' }}>
              <SaveButton onClick={handleSubmit(onSubmit)}>{'บันทึก'}</SaveButton>

              <CancelButton
                onClick={() => {
                  setIsExpanded(true)
                  setIsAddBankAccount(false)
                  setSelectRowData()
                }}
              >
                ยกเลิก
              </CancelButton>
            </Col>
          </Row>

          <ConfirmWidget
            title={'ยืนยันการ' + (isAddBankAccount ? 'เพิ่ม' : 'แก้ไข')}
            show={isShowConfirm}
            detail={'ยืนยันการ' + (isAddBankAccount ? 'เพิ่ม' : 'แก้ไข')}
            onCancle={() => setIsShowConfirm(false)}
            onConfirm={handleCallService}
          />
        </Panel>
      )}
    </>
  )
}